import React from 'react';
import { Layout, theme, Typography } from 'antd';
import PropTypes from 'prop-types';

const ApplicationContainer = ({ title = null, children = null }) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <div className="container">
      <Layout
        style={{
          padding: '24px 0',
          marginTop: 15,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        <Layout.Content style={{ padding: '0 48px' }}>
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 24,
              borderRadius: borderRadiusLG,
            }}
          >
            <Typography.Title>{title}</Typography.Title>
            {children}
          </div>
        </Layout.Content>
      </Layout>
    </div>
  );
};

ApplicationContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ApplicationContainer;
